import { BaseService } from './BaseService';
import { FetchResult } from 'apollo-link';
import BillCreate from '@/graphql/mutations/BillCreate.gql';
import fetchBillQuery from '@/graphql/queries/FetchBill.gql';
import ScopedListBillsQuery from '@/graphql/queries/ScopedListBills.gql';
import updateBill from '@/graphql/mutations/BillUpdate.gql';
import deleteBill from '@/graphql/mutations/BillDelete.gql';
import billPublish from '@/graphql/mutations/BillPublish.gql';
import billRegenerate from '@/graphql/mutations/BillRegenerate.gql';
import { ApolloQueryResult } from 'apollo-client';
import {
  fetchBill,
  ScopedListBills,
  ShipmentScopedInput,
  BillCreate_createBill,
  BillInput,
  BillScopedInput,
  BillUpdate,
  BillDelete,
  BillPublish,
  AvailableLocalesEnum
} from '@/types/graphql/schemaTypes';

class BillService extends BaseService {
  /**
   * Below is deprecated - to be removed when partial bill payment is finished.
   */
  public createBill(shipmentsArgs: ShipmentScopedInput[], language: AvailableLocalesEnum):
    Promise<FetchResult<BillCreate_createBill>> {
    return this.client.mutate({
      mutation: BillCreate,
      variables: {
        shipmentsArgs,
        language
      }
    });
  }

  public createPartialBill(billItemIds: string[], language: AvailableLocalesEnum):
    Promise<FetchResult<BillCreate_createBill>> {
    return this.client.mutate({
      mutation: BillCreate,
      variables: {
        language,
        billItemIds
      }
    });
  }

  public scopedListBills(billArgs: BillScopedInput):
    Promise<ApolloQueryResult<ScopedListBills>> {
    return this.client.query({
      query: ScopedListBillsQuery,
      variables: {
        billArgs
      }
    }).then((result: ApolloQueryResult<any>) => {
      return result;
    });
  }

  public fetchBill(billId: string): Promise<ApolloQueryResult<fetchBill>> {
    return this.client.query({
      query: fetchBillQuery,
      variables: {
        billArgs: {
          billId
        }
      }
    });
  }

  public updateBill(billArgs: BillInput, billItemIds?: string[]):
    Promise<FetchResult<BillUpdate>> {
    return this.client.mutate({
      mutation: updateBill,
      variables: {
        billArgs,
        billItemIds
      }
    });
  }

  public deleteBill(billArgs: BillInput):
    Promise<FetchResult<BillDelete>> {
    return this.client.mutate({
      mutation: deleteBill,
      variables: {
        billArgs
      }
    });
  }

  public publishBill(billArgs: BillInput): Promise<FetchResult<BillPublish>> {
    return this.client.mutate({
      mutation: billPublish,
      variables: {
        billArgs
      }
    });
  }

  public regenerateBill(billId: string) {
    return this.client.mutate({
      mutation: billRegenerate,
      variables: {
        billId
      }
    });
  }
}

export const billService = new BillService();
